import React from 'react';
import Banner from "./Banner/Banner";
import NavBar from './NavBar/NavBar';

import classes from './App.module.scss';
import About from "./About/About";
import { Benefits } from './Benefits/Benefits';
import { Footer } from './Footer/Footer';




function App() {
    const {intro, links, email, address} = {
        intro: { title: "Casa Kotys",
            paragraph: "Casa Kotys is located in Albeștii Pănâteni village, in the middle of nature, but also close to" +
                " the main road, Transfăgărășan",
        },
        links: [{ href: "#", text: "Home" }, { href: "#", text: "Rooms" }, { href: "#", text: "Activities" }, { href: "#", text: "Contact" }],
        email:"casa.nitulescu@gmail.com",
        address:"117 Gelu Ciuculescu, Albeștii"
    };

    const benefits = [
        {icon:"flaticon-wifi",
        title:"Free Wifi",
        paragraph:"Wifi available inside the building", className:"col-md-3"},
        {icon:"flaticon-parking-area",
            title:"Free Parking",
            paragraph:"We provide parking space in the courtyard",
            className:"col-md-3"},
        {icon:"flaticon-kitchen",
            title:"Kitchen",
            paragraph:"A completely equipped kitchen and a dinning area",
            className:"col-md-3"},
        {icon:"flaticon-tv",
            title:"TV Room",
            paragraph:"The living room has flat screen TV",
            className:"col-md-2"},];
    return (
        <div className={classes.App}>
            <NavBar/>
            <Banner/>
            <About/>
            <Benefits services={benefits}/>
            <Footer intro={intro} address={address} email={email} links={links}/>
        </div>
    );
}

export default App;
